import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=2af5b356&"
import script from "./InfoCard.vue?vue&type=script&lang=ts&"
export * from "./InfoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports